import { render, staticRenderFns } from "./VariablePostalCode.vue?vue&type=template&id=191b464b&"
import script from "./VariablePostalCode.vue?vue&type=script&lang=ts&"
export * from "./VariablePostalCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports